import HeartShapedBox from './HeartShapedBox';

export default HeartShapedBox;
